import React, { useState } from "react";
import { auth } from "../firebase";
import { useNotifications } from "../hooks/notificationsContext";
import "./MyCompany.css";

export default function CompanyDetailsTab({ companyDoc, setCompanyDoc, userCEO }) {
  const [companyDetailsInput, setCompanyDetailsInput] = useState("");
  const [updatingDetails, setUpdatingDetails] = useState(false);
  const { addMessage } = useNotifications();

  const handleUpdateCompanyDetails = async () => {
    if (!userCEO || !companyDoc || !companyDetailsInput.trim()) return;
    setUpdatingDetails(true);

    try {
      const token = await auth.currentUser.getIdToken(true);
      const res = await fetch(
        `https://companychangedescription-5dhfwyjvzq-uc.a.run.app`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ticker: companyDoc.id,
            description: companyDetailsInput,
          }),
        }
      );

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      setCompanyDoc((prev) => ({
        ...prev,
        companyDescription: companyDetailsInput,
      }));

      addMessage("Company details updated.", "success");
      setCompanyDetailsInput("");
    } catch (err) {
      console.error("Failed to update company details:", err);
      addMessage("Failed to update company details.", "error");
    } finally {
      setUpdatingDetails(false);
    }
  };

  if (!companyDoc) return <p className="loading-text">Loading...</p>;

  return (
    <div className="issue-tab-container">
      <div className="issue-stats-grid">
        <div className="stat-card highlight">
          <div className="stat-value">{companyDoc.companyName || companyDoc.id}</div>
        </div>
      </div>

      <div className="issue-main-content">
        {/* Current Description Card */}
        <div className="issue-preview-card">
          <h4>Current Description</h4>
          <p className="description-display">
            {companyDoc.companyDescription || "No description."}
          </p>
        </div>

        {/* Edit Section */}
        <div className="input-section">
          <div className="cool-input-group">
            <label>Update Description</label>
            <textarea
              value={companyDetailsInput}
              onChange={(e) => setCompanyDetailsInput(e.target.value)}
              className="corporate-textarea"
              placeholder="Enter new company description..."
            />
          </div>
        </div>
      </div>

      <div className="action-area">
        <button
          className={`issue-btn-active ${updatingDetails ? 'loading' : ''}`}
          disabled={updatingDetails || !companyDetailsInput.trim()}
          onClick={handleUpdateCompanyDetails}
        >
          {updatingDetails ? "Updating Description" : "Update Description"}
        </button>
      </div>
    </div>
  );
}